import {IUser} from "../../interfaces";

export const getFullNameFromUser = (user: IUser) => {
  return `${user?.first_name ?? ''} ${user?.last_name ?? ''}`
}
export const getEmailFromUser = (user: IUser) => {
  return `${user?.email ?? ''}`
}